import type { App } from 'vue'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'

export const registerPrimeVueServices = (app: App) => {
  app.use(ToastService)
  app.use(DialogService)
  app.use(ConfirmationService)
}
